"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.authenticateSuccess = exports.authenticateError = exports.authenticateDelegateReset = exports.authenticateDelegateAccess = void 0;
var _authenticate = require("./authenticate.constant");
// common success
var authenticateSuccess = function authenticateSuccess(actionType, data) {
  return {
    type: _authenticate.actionTypes.SUCCESS,
    payload: {
      actionType: actionType,
      data: data
    }
  };
};

// common error
exports.authenticateSuccess = authenticateSuccess;
var authenticateError = function authenticateError(actionType, error) {
  return {
    type: _authenticate.actionTypes.ERROR,
    payload: {
      actionType: actionType,
      error: error
    }
  };
};

/**
 * Delegate access
 * @param payload
 * @returns api response
 * @description this function used to get access with id.
 */
exports.authenticateError = authenticateError;
var authenticateDelegateAccess = function authenticateDelegateAccess(data) {
  return {
    type: _authenticate.actionTypes.DELEGATE_ACCESS,
    payload: data
  };
};

/**
 * Reset
 * @param payload
 * @returns api response
 * @description this function used to reset states.
 */
exports.authenticateDelegateAccess = authenticateDelegateAccess;
var authenticateDelegateReset = function authenticateDelegateReset(data) {
  return {
    type: _authenticate.actionTypes.RESET,
    payload: data
  };
};
exports.authenticateDelegateReset = authenticateDelegateReset;